module.exports = __webpack_public_path__ + "img/smokapp_logo_blanco.45a866bd.png";